import React, {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {InsuranceCartsContext} from "../util/Context";
import ClayLoadingIndicator from "@clayui/loading-indicator";
import {addCart, selectCart} from "../util/Api";
import ClayAutocomplete from "@clayui/autocomplete";

export default function InsuranceCaseSelect({insuranceId}) {
    const insuranceCartsContext = useContext(InsuranceCartsContext);
    const insuranceCarts = insuranceCartsContext?.insuranceCarts?.extendedCart?.length > 0 ?
        insuranceCartsContext.insuranceCarts.extendedCart : [];
    //dont change to ===
    const currentCartIsOfInsurance = insuranceCarts.some(insuranceCart => insuranceCart.cart.cartId == insuranceCartsContext.currentCartId)

    const {t} = useTranslation();
    const [caseNumber, setCaseNumber] = useState(currentCartIsOfInsurance ? insuranceCartsContext.currentCartName : "");

    useEffect(() => {
        if (currentCartIsOfInsurance) {
            setCaseNumber(insuranceCartsContext.currentCartName);
        }
    }, [insuranceCartsContext.currentCartName, currentCartIsOfInsurance]);

    if (insuranceCartsContext.insuranceCartsLoading) return <ClayLoadingIndicator/>
    if(insuranceId === 0 || insuranceId === "0") return null;
    const getCaseNumber = (cart) => {
        return cart.customFields.find(customField => customField.name === 'insuranceCaseNumber');
    }

    const addCartAction = (name, insuranceId, insuranceCaseNumber) => {
        if(insuranceId && insuranceId > 0 && !insuranceCaseNumber) {
            alert(t("please-fill-insurance-case-number"));
            return;
        }
        window.showLoadingOverlay(true);
        addCart(name, insuranceId, insuranceCaseNumber)
            .then(response => {
                onInsuranceCaseChange(response.id);
            }).catch(error => alert(t("an-unexpected-error-occurred")))
            .finally(() => window.showLoadingOverlay(false));
    }

    const insuranceCaseChange = (newValue) => {
        if (newValue === "0") {
            return;
        }
        window.showLoadingOverlay(true);
        selectCart(newValue)
            .then(() => {onInsuranceCaseChange(newValue)})
            .catch(e => alert(t("an-unexpected-error-occurred")))
            .finally(() => window.showLoadingOverlay(false));
    }

    const onInsuranceCaseChange = (newValue) => {
        if (newValue === "0") {
            return;
        }
        Liferay.fire("current-order-updated");
        window.refreshMiniCarts();
        window.refreshCartSelect();
        insuranceCartsContext.onNewCartAdded();
    }

    return (
        <div>
            <div className="form-group input-text-wrapper">
                <label className="control-label"
                       htmlFor="insurance-case-select">
                    {t('insurance-case-number')}
                </label>

                <ClayAutocomplete id={"insurance-case-select"}
                                  placeholder={currentCartIsOfInsurance ? insuranceCartsContext.currentCartName : ""}
                    onClick={() => setCaseNumber("")}
                                  value={caseNumber}
                                  onChange={value => setCaseNumber(value)}>
                    {insuranceCarts.filter(insuranceCart => getCaseNumber(insuranceCart)).map(insuranceCart => (
                        <ClayAutocomplete.Item key={insuranceCart.cart.cartId}
                                               onClick={() => insuranceCaseChange(insuranceCart.cart.cartId)}>
                            {getCaseNumber(insuranceCart).value}
                        </ClayAutocomplete.Item>
                    ))}
                    {(caseNumber?.length || insuranceCarts.length === 0) &&
                        (
                            <ClayAutocomplete.Item key={"ADD_NEW"} onClick={() => addCartAction(caseNumber, insuranceId, caseNumber)}
                                                   textValue={caseNumber}>
                                {t("add-new-insurance-case-number")}: {caseNumber}
                            </ClayAutocomplete.Item>
                        )
                    }
                </ClayAutocomplete>
                <div className={"add-new-insurance-case"}>
                    <p>{t("select-insurance-case-text")}</p>
                </div>
            </div>
        </div>
    )
}